import { Flex } from "antd";
import { Button, Icon } from "ui";

export const Addresses = () => {
  return (
    <div className="box">
      <Flex align="center" justify="space-between">
        <h1>کتابچه ادرس ها</h1>
        <Button type="success-75" size="large">
          <Icon type="sr-plus" />
          افزودن آدرس جدید
        </Button>
      </Flex>
    </div>
  );
};
